import { useSearchParams } from 'react-router-dom';
import { Alert, Box, Stack, Typography } from '@mui/material';

import FaceDownDeck from '@/components/reading/FaceDownDeck';
import ReadingControls from '@/components/reading/ReadingControls';
import RevealedReading from '@/components/reading/RevealedReading';
import SpreadSelector from '@/components/reading/SpreadSelector';
import { DEFAULT_SPREAD, isSpreadKey, SPREADS } from '@/data/spreads';
import { useReading } from '@/hooks/useReading';

import { readingAlertSx, readingDescriptionSx, readingTitleSx } from './Reading.styles';

function Reading() {
  const [searchParams] = useSearchParams();
  const queryParam = searchParams.get('spread');
  const initialSpread = isSpreadKey(queryParam) ? queryParam : DEFAULT_SPREAD;

  const {
    spread,
    setSpread,
    shuffled,
    drawn,
    showResult,
    cardBack,
    requiredCards,
    selectedCount,
    shuffleDeck,
    toggleSelect,
    completeReading,
    reset,
  } = useReading(initialSpread);

  const hasShuffled = shuffled.length > 0;

  return (
    <Stack spacing={4}>
      <Box>
        <Typography variant="h4" component="h1" color="primary" sx={readingTitleSx}>
          New Reading
        </Typography>
        <Typography variant="body2" sx={readingDescriptionSx}>
          Select a spread type and shuffle the cards to begin your reading.
        </Typography>
      </Box>

      <SpreadSelector value={spread} onChange={setSpread} />

      {!showResult && (
        <ReadingControls
          hasShuffled={hasShuffled}
          selectedCount={selectedCount}
          requiredCards={requiredCards}
          onShuffle={shuffleDeck}
          onComplete={completeReading}
        />
      )}

      {!showResult && hasShuffled && (
        <FaceDownDeck
          shuffled={shuffled}
          cardBack={cardBack}
          requiredCards={requiredCards}
          onToggle={toggleSelect}
        />
      )}

      {showResult && (
        <RevealedReading
          spread={SPREADS[spread]}
          drawn={drawn}
          onNewReading={reset}
          onReshuffle={shuffleDeck}
        />
      )}

      {!hasShuffled && !showResult && (
        <Alert severity="info" sx={readingAlertSx}>
          Click &quot;Shuffle Deck&quot; to begin. Then select the cards that speak to you for your
          reading.
        </Alert>
      )}
    </Stack>
  );
}

export default Reading;
